/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React from 'react';
import UpgradeCard from '../../components/UpgradeCard';
import { CREDITS_1, CREDITS_MEMBERSHIP, CREDITS_SMART } from '../../lib/constants';

const UpgradeCardCrediti: React.FC = function UpgradeCardCrediti() {
  return (
    <>
      <div
        className="relative flex flex-col lg:flex-row space-x-0 lg:space-x-10 space-y-6 lg:space-y-0 justify-center items-center mt-16">
        <UpgradeCard name="Card Crediti 1" price="590€" dataId={CREDITS_1} buttonText="Acquista">
          <li>
            <b>1</b> profili a scelta
          </li>
          <li>Nessuna scadenza</li>
          <li>Garanzia crediti<sup>*</sup></li>
           <li>Support dedicato</li>
        </UpgradeCard>
        <UpgradeCard name="Card Crediti 5" price="2.450€" dataId={CREDITS_SMART} buttonText="Acquista">
          <li>
            <b>5</b> profili a scelta
          </li>
          <li>Nessuna Scadenza</li>
          <li>Garanzia crediti<sup>*</sup></li>
           <li>Support dedicato</li>
        </UpgradeCard>
        <UpgradeCard name="Card Crediti 10" price="4.200€" dataId={CREDITS_MEMBERSHIP} buttonText="Acquista">
          <li>
            <b>10</b> profili a scelta
          </li>
          <li>Nessuna Scadenza</li>
          <li>Garanzia crediti<sup>*</sup></li>
           <li>Support dedicato</li>
        </UpgradeCard>
      </div>
      <div
        className="relative flex flex-col items-center mt-6 space-y-4 max-w-2xl text-justify mx-auto pb-10 lg:pb-0 mb-6">
        <p className="text-[11px] text-black font-primarylight">
          <b>* Garanzia crediti</b>: ottieni sempre il colloquio di lavoro o riconverti il credito. Si applica nel caso in cui il candidato non sia reperibile telefonicamente o via email per 7 giorni consecutivi
dal primo tentativo di contatto o non sia più disponibile ad un colloquio di lavoro.<br />         
        </p>
      </div>

      <div
        className="relative flex flex-col lg:flex-row space-x-0 lg:space-x-10 space-y-6 lg:space-y-0 justify-center items-center mt-16">
        <div className="flex justify-center">
          <a
            className="w-[260px] text-sm flex justify-center items-center px-6 py-2 font-primarybold rounded-full text-white bg-primary
                      border-[1px] border-primary focus:outline-none disabled:bg-grey disabled:border-grey text-[14px] text-center"
            href="mailto:support@hrmeccatronica.com?subject=Sono interessato a CARD PERSONALIZZATA">Richiedi<br />CARD
            PERSONALIZZATA</a>
        </div>
        <div className="mt-6 flex justify-center">
          <a
            className="w-[260px] text-sm flex justify-center items-center px-6 py-2 font-primarybold rounded-full text-white bg-primary
                      border-[1px] border-primary focus:outline-none disabled:bg-grey disabled:border-grey text-[14px] text-center"
            href="mailto:support@hrmeccatronica.com?subject=Sono interessato a GARANZIA CREDITI">Richiedi<br />GARANZIA
            CREDITI</a>
        </div>
        <div className="mt-6 flex justify-center">
          <a
            className="w-[260px] text-sm flex justify-center items-center px-6 py-2 font-primarybold rounded-full text-white bg-primary
                      border-[1px] border-primary focus:outline-none disabled:bg-grey disabled:border-grey text-[14px] text-center"
            href="mailto:support@hrmeccatronica.com?subject=Sono interessato a ASSISTENZA">Richiedi<br />ASSISTENZA</a>
        </div>
      </div>
    </>
  );
};

export default UpgradeCardCrediti;
